// extracted by mini-css-extract-plugin
module.exports = {"header":"AnatomySection_header__LgalI small-caps","description":"AnatomySection_description__ey7W_","quantity":"AnatomySection_quantity__WkSPk"};